import React from 'react';
import { Breadcrumbs, PageScaffold } from '../ui';
import ProjectsExperience from './projects/ProjectsExperience';

/**
 * Workspace · Projects — discovery hub into project workspaces.
 * Stays in workspace sidebar mode (no /project_X/ in the URL until Open Project).
 */
const ProjectsWorkspace = () => (
  <PageScaffold
    title="Projects"
    description="Manage your test automation projects, repositories and execution environments."
    breadcrumbs={<Breadcrumbs items={[{ label: 'Workspace' }, { label: 'Projects' }]} />}
  >
    <ProjectsExperience />
  </PageScaffold>
);

export default ProjectsWorkspace;
